/**
 * variant-image-sync.js
 * Ride theme – kép léptetés → variáns szinkronizáció
 * 
 * Ha a felhasználó a termékképek között léptet (slider),
 * automatikusan a képhez tartozó variáns lesz aktív.
 */

(function () {
  'use strict';
  
  const variantDescMap = JSON.parse(document.getElementById('variant-description-map')?.textContent || '{}');

  function initVariantImageSync() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const slider = mediaGallery.querySelector('ul.slider');
    if (!slider) return;


    const mapEl = document.getElementById('variant-media-map');
    if (!mapEl) return;


    const mediaToVariant = JSON.parse(mapEl.textContent);
    if (Object.keys(mediaToVariant).length === 0) return;

    attachScrollListener(slider, mediaToVariant);
  }
  document.addEventListener('change', (event) => {
    const input = event.target.closest('variant-selects input[type="radio"]');
    if (!input) return;
    
    const idInput = document.querySelector('product-form input[name="id"]');
    if (!idInput) return;

    const observer = new MutationObserver(() => {
      observer.disconnect();
      const variantId = idInput.value;
      const variantDescEl = document.querySelector('div[id^="variant-description-"]');
      if (variantDescEl) {
        const desc = variantDescMap[String(variantId)] ?? '';
        variantDescEl.textContent = desc;
        variantDescEl.style.display = desc ? 'block' : 'none';
      }
    });

    observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    
    // Fallback: ha 1 másodpercen belül nem változik, mégis frissítünk
    setTimeout(() => {
      observer.disconnect();
      const variantId = idInput.value;
      const variantDescEl = document.querySelector('div[id^="variant-description-"]');
      if (variantDescEl) {
        const desc = variantDescMap[String(variantId)] ?? '';
        variantDescEl.textContent = desc;
        variantDescEl.style.display = desc ? 'block' : 'none';
      }
    }, 1000);
  });
function attachScrollListener(slider, mediaToVariant) {
  let scrollTimer = null;
  let lastActiveMediaId = null;
  let lastScrollLeft = 0;

  const sliderContainer = slider.closest('slider-component') || slider.parentElement;

  const handleInteraction = () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const activeSlide = getActiveSlide(slider);
      if (!activeSlide) return;

      const rawMediaId = activeSlide.dataset.mediaId;
      if (!rawMediaId || rawMediaId === lastActiveMediaId) return;

      const currentScrollLeft = slider.scrollLeft;
      const scrolledForward = currentScrollLeft >= lastScrollLeft;
      lastScrollLeft = currentScrollLeft;
      lastActiveMediaId = rawMediaId;

      const numericMediaId = extractNumericMediaId(rawMediaId);
      if (!numericMediaId) return;

      const variantId = mediaToVariant[numericMediaId];
      if (!variantId) return;

      const currentVariantId = getCurrentVariantId();
      if (currentVariantId && String(currentVariantId) === String(variantId)) return;

      if (!scrolledForward) {
        const firstMediaIdForVariant = Object.entries(mediaToVariant)
          .find(([, vId]) => String(vId) === String(variantId))?.[0];
        if (String(numericMediaId) !== String(firstMediaIdForVariant)) return;
      }
      selectVariant(variantId, numericMediaId);
    }, 150);
  };

  sliderContainer.addEventListener('touchend', handleInteraction);
  sliderContainer.addEventListener('click', handleInteraction);

}



  function getActiveSlide(slider) {
    const slides = Array.from(slider.querySelectorAll('li.product__media-item.slider__slide'));
    if (slides.length === 0) return null;

    const sliderRect = slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + sliderRect.width / 2;

    let closest = null;
    let closestDistance = Infinity;

    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;
      const distance = Math.abs(slideCenter - sliderCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = slide;
      }
    });

    return closest;
  }

  function extractNumericMediaId(rawMediaId) {
    const parts = rawMediaId.split('-');
    const numeric = parts[parts.length - 1];
    return /^\d+$/.test(numeric) ? parseInt(numeric, 10) : null;
  }

  function getCurrentVariantId() {
    const input = document.querySelector('product-form input[name="id"]');
    return input ? input.value : null;
  }

  /*function selectVariant(variantId) {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    fetch(`/variants/${variantId}.js`)
      .then(r => r.json())
      .then(variant => {
        variant.options.forEach((optionValue) => {
          const radio = variantSelects.querySelector(
            `input[type="radio"][value="${CSS.escape(optionValue)}"]`
          );
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      })
      .catch(err => console.warn('[variant-image-sync]', err));
  }*/
function selectVariant(variantId, targetMediaId) {
  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  const gallery = document.querySelector('media-gallery');
  const sectionId = document.querySelector('product-info')?.dataset.section;
  const targetFullId = `${sectionId}-${targetMediaId}`;

  // Elfogás: ha a téma setActiveMedia-t hív, mi felülírjuk a targettel
  if (gallery) {
    const original = gallery.setActiveMedia.bind(gallery);
    gallery.setActiveMedia = (mediaId, prepend) => {
      // Visszaállítjuk az eredetit
      gallery.setActiveMedia = original;
      // Mindig a mi képünkre ugrunk, nem a témáéra
      original(targetFullId, false);
    };
  }

  fetch(`/variants/${variantId}.js`)
    .then(r => r.json())
    .then(variant => {
      variant.options.forEach((optionValue) => {
        const radio = variantSelects.querySelector(
          `input[type="radio"][value="${CSS.escape(optionValue)}"]`
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    })
    .catch(err => {
      if (gallery) gallery.setActiveMedia = gallery.setActiveMedia.bind(gallery);
      console.warn('[variant-image-sync]', err);
    });
  // section.id helyett a tényleges section ID-t kell beégetni, pl.:
  //const variantDescEl = document.querySelector('[id^="variant-description-"]');
  const variantDescEl = document.querySelector('div[id^="variant-description-"]');

  if (variantDescEl) {
    const desc = variantDescMap[String(variantId)] ?? '';
    variantDescEl.textContent = desc;
    variantDescEl.style.display = desc ? 'block' : 'none';
  }
}



  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantImageSync);
  } else {
    initVariantImageSync();
  }

  document.addEventListener('product-info:loaded', initVariantImageSync);
})();
